/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'

function EMAILCARD({title, message, date}: any) {
  const [emailModalOpen, setEmailModalOpen] = useState(false)
  const truncateText = (text: string, maxLength: number) => {
    if (text.length <= maxLength) {
      return text
    } else {
      return text.slice(0, maxLength) + '...'
    }
  }
    // Email form
    const openModal = () => {
      setEmailModalOpen(true)
    }
    const closeModal = () => {
      setEmailModalOpen(false)
    }
  return (
    <div className='d-lg-flex align-items-center '>
      <span className='svg-icon svg-icon-primary svg-icon-2x me-3'>

        <KTSVG
            path='/media/icons/email-sent.svg'
            className='svg-icon-2 svg-icon-gray-500'
          />
      </span>

      <div className='me-3 flex-grow-1 w-lg-75'>
        <div className='d-flex align-items-center'>
          <a
          onClick={openModal}
          className='fs-5 text-dark fw-bold text-hover-primary text-dark lh-base cursor-pointer'
        >
          {title}
        </a>
        </div>
        <div className='text-muted'>{message}</div>
      </div>
      <div className='text-dark fw-medium'>
        <div className='text-dark'>{date}</div>
      </div>
            {/* MODAL => Email */}
            {emailModalOpen && (
        <div
          className='modal'
          tabIndex={-1}
          role='dialog'
          style={{display: 'block'}}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'  style={{minHeight:500}}>
              <div className='modal-header' style={{backgroundColor:'#CFCFCF'}}>
                <h5 className='modal-title'>Email Details</h5>
                <button type='button' className='btn-close' onClick={closeModal}>
                  {/* <span>&times;</span> */}
                </button>
              </div>

              <div className='modal-body'>
                <div className='form-group d-flex'>
                  <label
                    htmlFor='title'
                    className='fs-5 fw-bold align-self-center w-20'
                    style={{width: '30%'}}
                  >
                    Email Subject:
                  </label>
                  <p className='fs-5 s text-dark fw-bold text-hover-primary text-dark lh-base mt-4'>
                    {title}
                  </p>
                </div>
                <div className='form-group d-flex'>
                  <label
                    htmlFor='title'
                    className='fs-5 fw-bold align-self-center w-20'
                    style={{width: '30%'}}
                  >
                    Email Body:
                  </label>
                  <p className='fw-semibold fs-5 text-gray-600 text-dark my-4 text-justify'>
                  <div dangerouslySetInnerHTML={{__html: truncateText(message, 10000)}} />
                  </p>
                </div>

                
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EMAILCARD
